import React, { useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { verifyOtpServ, resendOtpServ } from "../../services/authentication.services";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import "./login.css"; // Ensure you add the CSS below to this file

function OtpVerification() {
  const navigate = useNavigate();
  const [emailOtp, setEmailOtp] = useState(new Array(6).fill(""));
  const [phoneOtp, setPhoneOtp] = useState(new Array(6).fill(""));
  const emailInputs = useRef([]);
  const phoneInputs = useRef([]);

  const handleChange = (element, index, type) => {
    const value = element.value;
    if (isNaN(value)) return false;

    if (type === "email") {
      let newOtp = [...emailOtp];
      newOtp[index] = value.substring(value.length - 1);
      setEmailOtp(newOtp);
      // Move to next input
      if (value && index < 5) emailInputs.current[index + 1].focus();
    } else {
      let newOtp = [...phoneOtp];
      newOtp[index] = value.substring(value.length - 1);
      setPhoneOtp(newOtp);
      // Move to next input
      if (value && index < 5) phoneInputs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index, type) => {
    if (e.key === "Backspace") {
      if (type === "email" && !emailOtp[index] && index > 0) {
        emailInputs.current[index - 1].focus();
      } else if (type === "phone" && !phoneOtp[index] && index > 0) {
        phoneInputs.current[index - 1].focus();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const finalEmailOtp = emailOtp.join("");
    const finalPhoneOtp = phoneOtp.join("");

    if (finalEmailOtp.length < 6 || finalPhoneOtp.length < 6) {
      toast.error("Please enter complete OTPs");
      return;
    }

    try {
      const response = await verifyOtpServ({ emailOtp: finalEmailOtp, phoneOtp: finalPhoneOtp });
      if (response?.data?.statusCode === "200") {
        toast.success("Verified!");
        navigate("/dashboard");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Invalid OTP");
    }
  };

  return (
    <div className="signin-container">
      <div className="signin-card text-center">
        <h2>Verify Identity</h2>
        <p className="text-muted">Enter the 6-digit codes sent to you</p>

        <form onSubmit={handleSubmit}>
          {/* Email OTP Section */}
          <div className="otp-section mb-4">
            <label className="form-label d-block text-start">Email OTP</label>
            <div className="d-flex justify-content-between">
              {emailOtp.map((data, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  className="otp-input"
                  ref={(el) => (emailInputs.current[index] = el)}
                  value={data}
                  onChange={(e) => handleChange(e.target, index, "email")}
                  onKeyDown={(e) => handleKeyDown(e, index, "email")}
                />
              ))}
            </div>
          </div>

          {/* Phone OTP Section */}
          <div className="otp-section mb-4">
            <label className="form-label d-block text-start">Phone OTP</label>
            <div className="d-flex justify-content-between">
              {phoneOtp.map((data, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  className="otp-input"
                  ref={(el) => (phoneInputs.current[index] = el)}
                  value={data}
                  onChange={(e) => handleChange(e.target, index, "phone")}
                  onKeyDown={(e) => handleKeyDown(e, index, "phone")}
                />
              ))}
            </div>
          </div>

          <button type="submit" className="btn btn-gradient w-100 mt-3">
            Verify & Proceed
          </button>
        </form>

        <div className="mt-4">
          <Link to="/" className="text-info">Back to Login</Link>
        </div>
      </div>
    </div>
  );
}

export default OtpVerification;